export enum DashboardThemes {
  LIGHT,
  DARK
}
